import {
  SubmitAnswerRequest,
  SubmitAnswerResponse,
  TriviaLeaderboardStatsResponse,
  TriviaRumbleCostResponse,
  TriviaRumbleInfoResponse,
  TriviaRumbleLeaderboardResponse,
  TriviaRumbleQuestionResponse,
} from '@wwe-portal/entities/trivia-rumble.type';
import { nestApiClient } from './api-client';

export const getTriviaStats = () => {
  return nestApiClient.get<TriviaLeaderboardStatsResponse>(
    `/trivia/v2/user/stats`
  );
};

export const getTriviaCost = () => {
  return nestApiClient.get<TriviaRumbleCostResponse>(`/trivia/v2/energy-cost`);
};

export const getTriviaInfo = () => {
  return nestApiClient.post<TriviaRumbleInfoResponse>(`/trivia/v2`);
};

export const getTriviaQuestion = (gameId: number) => {
  return nestApiClient.get<TriviaRumbleQuestionResponse>(
    `/trivia/v2/question`,
    {
      params: {
        gameId,
      },
    }
  );
};

export const getTriviaContinue = ({ webCoin, gameId }) => {
  return nestApiClient.post<TriviaLeaderboardStatsResponse>(
    `/trivia/v2/continue`,
    {
      webCoin,
      gameId,
    }
  );
};

export const submitAnswer = async (data: SubmitAnswerRequest) => {
  return await nestApiClient.post<SubmitAnswerResponse>(
    `/trivia/v2/question`,
    data
  );
};

export const getTriviaLeaderboard = () => {
  return nestApiClient.get<TriviaRumbleLeaderboardResponse>(
    `/trivia/v2/leaderboard`
  );
};
